// extracted by mini-css-extract-plugin
module.exports = {"select":"PageFilter_select__1jSIO","extra":"PageFilter_extra__3CCK9","extraContent":"PageFilter_extraContent__14fOe"};